import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { ReactNode, useState, useRef, useEffect, MouseEvent } from "react";
import { useNavigate, Routes } from "react-router";
import { Fragment } from "react/jsx-runtime";
import { AppBarContext, IAppBarState } from "../Hooks/AppBarContext";
import { useEventStats } from "../Hooks/EventStatsContext";
import { userSettingsStore } from "../Services/UserSettingsStore";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as LogoImage } from '../Images/GK.svg';
import { ReactComponent as LogoLargeImage } from '../Images/logo_GateKeeper.svg';
import "./AppBar.scss"
import EventQuickStats from "../Pages/EventQuickStats";
import { appSettings } from "../AppSettings";

export function AppBar(props: { routes: ReactNode[] }) {

    const [appBarState, setAppBarState] = useState({
        backVisible: false,
        isMenuOpen: false
    } as IAppBarState);

    const [quickStatsAnchor, setQuickStatsAnchor] = useState(null as HTMLElement);

    const quickStatsTimer = useRef(null as number);

    const navigate = useNavigate();

    const menuAnchor = useRef();

    const userLogo = userSettingsStore.current?.logo ?? "/assets/logo_boxol.png";

    const stats = useEventStats();

    const [checkedIn, setCheckedIn] = useState("" as string);



    useEffect(() => {

        if (stats.lastStats.Totale)
            setCheckedIn(Math.round(stats.lastStats.Entrati / stats.lastStats.Totale * 100) + "%");
        else
            setCheckedIn("N/A");

    }, [stats.eventId, stats.lastUpdate]);

    const changeAppBarState = (state: Partial<IAppBarState>) => {
        setAppBarState({
            ...appBarState,
            ...state
        });
    }

    const onBackClick = () => {
        navigate(-1);
    }


    const onStatsClick = (ev: MouseEvent) => {

        setQuickStatsAnchor(ev.currentTarget as HTMLElement);

        if (quickStatsTimer.current)
            clearTimeout(quickStatsTimer.current);

        if (appSettings.quickStatsTimeout) {
            quickStatsTimer.current = (setTimeout(() => {

                setQuickStatsAnchor(null);

            }, appSettings.quickStatsTimeout) as any);
        }
    }

    return <AppBarContext.Provider value={{ setState: setAppBarState }}>
        <header className={appBarState.largeLogo ? "large" : "small"}>

            {appBarState.backVisible ?
                <IconButton size="large" className="back" onClick={onBackClick}><ArrowBackIcon /></IconButton >
                : null
            }
            <div className="logo">
                {appBarState.largeLogo ?
                    <LogoLargeImage onClick={() => navigate("/about")} />
                    :
                    <LogoImage />
                }
            </div>
            {appBarState.title && <div className="title" onClick={onStatsClick}>
                <span className="section">{appBarState.title}</span>
                <span className="checked-in">{checkedIn}</span>
            </div>}
            {!appBarState.largeLogo && <div className="user-logo">
                <img src={userLogo} onClick={appBarState.onUserLogoClick} />
            </div>}
            {appBarState.actions?.length > 0 &&
                <Fragment>
                    <IconButton className="menu" ref={menuAnchor} onClick={() => changeAppBarState({ isMenuOpen: true })}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        id="basic-menu"
                        anchorEl={menuAnchor.current}
                        open={appBarState.isMenuOpen ?? false}
                        onClose={() => changeAppBarState({ isMenuOpen: false })}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {appBarState.actions?.map((a, i) =>
                            <MenuItem key={i} onClick={() => a.executeAsync()}>
                                <ListItemIcon>
                                    {a.icon}
                                </ListItemIcon>
                                <ListItemText>{a.body}</ListItemText>
                            </MenuItem>
                        )}
                    </Menu>
                </Fragment>
            }
        </header>
        <Routes>{props.routes}</Routes>
        <EventQuickStats anchor={quickStatsAnchor}  origin="bottom" onClose={() => setQuickStatsAnchor(null)} />
    </AppBarContext.Provider>

}